import { MultiSelectCard, OpenParagraphCard, RadioCard, SingleValueCard } from '@/pages/new-platform/components/SurveyCards';
import { Question } from '@/utils/api-objects/Question';
import { ANSWERS_OPENING_INPUT } from '@/utils/Constants';
import { QuestionType } from '@/utils/enums/Surveys';

interface QuestionCardProps {
    question: Question;
    singleValueAnswer: string;
    openParagraphAnswer: string;
    selectedRadioAnswer: string | null;
    selectedAnswers: Set<string>;
    customInputValue: string;
    choiceBecomesInput: boolean;
    isOldAnswerCustom: boolean;
    oldAnswerCustom: string;
    onSingleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onOpenParagraphChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onMultiSelectCardClick: (answer: string) => void;
    onRadioCardClick: (answer: string) => void;
    onCustomInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const QuestionCard: React.FC<QuestionCardProps> = ({
    question,
    singleValueAnswer,
    openParagraphAnswer,
    selectedRadioAnswer,
    selectedAnswers,
    customInputValue,
    choiceBecomesInput,
    isOldAnswerCustom,
    oldAnswerCustom,
    onSingleValueChange,
    onOpenParagraphChange,
    onMultiSelectCardClick,
    onRadioCardClick,
    onCustomInputChange,
}) => {
    return (
        <div className="w-full max-w-[860px] mx-auto space-y-4 md:space-y-6">
            {/* Single Value */}
            {(question.question_type === QuestionType.SingleValueText ||
                question.question_type === QuestionType.SingleValueNumber) && (
                <SingleValueCard
                    question={question}
                    value={singleValueAnswer}
                    onChange={onSingleValueChange}
                />
            )}

            {/* Radio */}
            {question.question_type === QuestionType.Radio && (
                <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                    {question.answers.map((answer, index) => (
                        <RadioCard
                            key={index}
                            answer={(ANSWERS_OPENING_INPUT.includes(answer) && oldAnswerCustom) ? oldAnswerCustom : answer}
                            onClick={onRadioCardClick}
                            isChecked={selectedRadioAnswer === answer}
                            isAnInput={choiceBecomesInput}
                            onInputChange={onCustomInputChange}
                            inputValue={customInputValue}
                        />
                    ))}
                </div>
            )}

            {/* MultiSelect */}
            {question.question_type === QuestionType.MultiSelect && (
                <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                    {question.answers.map((answer, index) => (
                        <MultiSelectCard
                            key={index}
                            answer={(ANSWERS_OPENING_INPUT.includes(answer) && oldAnswerCustom && Array.from(selectedAnswers).some(answer => !question.answers.includes(answer))) ? oldAnswerCustom : answer}
                            onClick={onMultiSelectCardClick}
                            isChecked={selectedAnswers.has(answer) || (ANSWERS_OPENING_INPUT.includes(answer) && isOldAnswerCustom && Array.from(selectedAnswers).some(answer => !question.answers.includes(answer)))}
                            isAnInput={choiceBecomesInput}
                            onInputChange={onCustomInputChange}
                            inputValue={customInputValue}
                        />
                    ))}
                </div>
            )}

            {/* OpenParagraph */}
            {question.question_type === QuestionType.OpenParagraph && (
                <OpenParagraphCard
                    question={question}
                    value={openParagraphAnswer}
                    onChange={onOpenParagraphChange}
                />
            )}
        </div>
    );
}; 